/* dv-transparent-header 2026-07-23: toggle .dv-past-hero on the header once the
   hero has scrolled up behind it, so the CSS knows when to switch from
   transparent to solid. Not on the homepage (no hero) => always solid.

   2026-07-28: the selector only knew about the VIDEO hero. When the PAYDAY25
   image hero took the top slot and the video hero was disabled, this found
   nothing, took the "no hero" branch and pinned .dv-past-hero on immediately -
   which silently disabled every white-logo and white-search rule in
   dv-transparent-header-v3.css. The logo went black on a black door and the
   search box rendered #444 on near-black.

   So HERO is now a list. Any future hero section must add its selector here or
   it will inherit the same invisible-header bug. */
(function () {
  var HERO = ".dv-video-hero-section, section.dvih";

  function update() {
    var header = document.querySelector(".section-header");
    if (!header) return;
    var hero = document.querySelector(HERO);
    if (!hero) { header.classList.add("dv-past-hero"); return; }
    var heroBottom = hero.getBoundingClientRect().bottom;
    var headerH = header.offsetHeight || 90;
    if (heroBottom <= headerH) header.classList.add("dv-past-hero");
    else header.classList.remove("dv-past-hero");
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", update);
  else update();
  window.addEventListener("load", update);
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
})();
